import { BaseModel } from "../base.model";

export type Synonyms = Synonym[];

type SynonymProps = {
  parentWord: string;
  parentDefinitionId: string;
  childWord: string;
  isVisible: boolean;
  canBeLyAdverb?: boolean;
  lyVariant?: string;
  displayOrder: number;
};

export class Synonym extends BaseModel {
  id: string;
  parentWord: string;
  parentDefinitionId: string;
  childWord: string;
  isVisible: boolean;
  canBeLyAdverb?: boolean;
  lyVariant?: string;
  displayOrder: number;

  constructor(data: SynonymProps) {
    super(data);
    this.parentWord = data.parentWord;
    this.parentDefinitionId = data.parentDefinitionId;
    this.childWord = data.childWord;
    this.isVisible = data.isVisible;
    this.canBeLyAdverb = data.canBeLyAdverb;
    this.lyVariant = data.lyVariant;
    this.displayOrder = data.displayOrder;
    this.id = this.generatedId;
  }

  override get databaseConfig() {
    return {
      collection: "synonyms",
      path: `/synonyms/${this.generatedId}`,
    };
  }

  static override fromMap(map: any) {
    return new Synonym(map);
  }

  get generatedId() {
    return `${this.parentWord.toLowerCase()}-${this.childWord.toLowerCase()}`;
  }
}
